// extracted by mini-css-extract-plugin
export default {"richText":"style_richText__5h6ac","content":"style_content__apMGD"};